module.exports = __webpack_public_path__ + "img/mrjoshuat-b90b0662-208d-43aa-fa2f-08d93be575f2.png";